import { datadogLogs } from '@datadog/browser-logs';
import { useAppSelector } from 'helpers/hooks';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';
import { getDonateConfig } from 'selectors/siteConfig';
import ErrorBoundaryWrapper from 'components/ErrorBoundaryWrapper';
import Error from 'components/Error';
import { Body } from 'components/Typography';
import { sanitizeHtml } from 'helpers/utils';
import { SearchScreen } from 'screens/Search';

export const CartScreen = () => {
  const donateShoppingCartConfig = useAppSelector(state =>
    getDonateConfig(state, 'donate_shopping_cart')
  );
  return (
    <ErrorBoundaryWrapper
      fallback={
        <Error
          data={{ component: 'Cart' }}
          errorMsg="Failure rendering Cart page"
          shouldAlert={true}
        >
          <Body>We encountered an error. Please contact support.</Body>
        </Error>
      }
      onError={(error, errorInfo) => {
        datadogLogs.logger.warn(
          'Shopping Cart page render error',
          { component: 'Cart', componentStack: errorInfo?.componentStack },
          error
        );
      }}
    >
      <HeaderAndFooterLayout headerVisible={true} footerVisible={true} isLoading={false}>
        <div className="cart-container">
          <span className="h1-mobile color-white">
            {donateShoppingCartConfig?.donate_shopping_cart_title}
          </span>
          <span
            className="h4-text color-white"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(donateShoppingCartConfig?.donate_shopping_cart_description),
            }}
          />
          <div className="cart-search-viewport">
            <SearchScreen clientIdParam={100} alwaysShowImpactScore />
          </div>
        </div>
      </HeaderAndFooterLayout>{' '}
    </ErrorBoundaryWrapper>
  );
};
